<template>
  <e-view
    class="right-container"
    :title="appData.selectedItem ? appData.selectedItem.name : ''"
    :subtitle="'APP.RIGHTCONTAINERSUBTITLE' | eLocales"
    :closeable="false">
    <template slot="header-right">
      <b-button
        :disabled="!appData.selectedItem || !appData.selectedItem.ext"
        @click="appData.saveFile">{{ 'APP.SAVEFILE' | eLocales }}</b-button>
      <div class="buttons has-addons content-toggle-btns">
        <b-button
          :disabled="appData.isFolder"
          :class="{ 'is-primary': appData.activeTab === 0 }"
          @click="appData.activeTab = 0"
        >{{ 'APP.DOCUMENT' | eLocales }}</b-button
        >
        <b-button :class="{ 'is-primary': appData.activeTab !== 0 }" @click="appData.activeTab = 1">
          {{ 'APP.KEYWORDING' | eLocales }}
        </b-button>
      </div>
    </template>
    <template v-if="appData.selectedItem !== null">
      <template v-if="appData.activeTab === 0">
        <document-view :config="docViewConfig"></document-view>
      </template>
      <template v-else>
        <span v-if="appData.selectedItem.xDate !== undefined">
          <b>{{ 'APP.XDATE' | eLocales }}</b>
          <div class="keyword-value">{{ renderDate(appData.selectedItem.xDate) }}</div>
        </span>
        <span v-if="appData.selectedItem.iDate !== undefined">
          <b>{{ 'APP.IDATE' | eLocales }}</b>
          <div class="keyword-value">{{ renderDate(appData.selectedItem.iDate) }}</div>
        </span>
        <span v-if="appData.selectedItem.desc !== undefined">
          <b>{{ 'APP.DESC' | eLocales }}</b>
          <div class="keyword-value">{{ appData.selectedItem.desc }}</div>
        </span>
        <span v-if="!appData.isFolder">
          <b>{{ 'APP.EXT' | eLocales }}</b>
          <div class="keyword-value">{{ appData.selectedItem.ext }}</div>
        </span>
        <span v-if="appData.selectedItem.owner !== undefined">
          <b>{{ 'APP.OWNER' | eLocales }}</b>
          <div class="keyword-value">{{ appData.selectedItem.owner }}</div>
        </span>
        <span v-for="objKey in getValidObjKeys(appData.selectedItem.keys)" :key="objKey.key">
          <b>{{ mask.lines[objKey.key].name }}</b>
          <div class="keyword-value">{{ renderText(objKey) }}</div>
        </span>
      </template>
    </template>
    <template v-else>
      <h3>{{ 'APP.EMPTYTEXT' | eLocales }}</h3>
    </template>
  </e-view>
</template>
<script>
import {EViewMixin} from '@elo/ui';
import {DateHelpers, Text} from '@elo/core';
import DocumentView from './DocumentView';

export default {
  name: 'ContentViewer',
  components: {DocumentView},
  mixins: [EViewMixin],
  inject: ['appData'],
  data() {
    return {};
  },
  methods: {
    getValidObjKeys(objKeys) {
      const me = this;

      const validObjKeys = [];

      if (objKeys) {
        objKeys.forEach((key) => {
          if (me.mask.lines[key.key]) {
            validObjKeys.push(key);
          }
        });
      }

      return validObjKeys;
    },
    renderText(objKey) {
      if (objKey) {
        return this.mask.lines[objKey.key].isDate ?
          this.renderDate(objKey.text) :
          objKey.text;
      } else {
        return '';
      }
    },
    renderDate(isoDate) {
      if (isoDate) {
        return DateHelpers.displayDate(DateHelpers.isoToDate(isoDate), true);
      } else {
        return '';
      }
    }
  },
  computed: {
    isFolder() {
      return this.appData.selectedItem && !this.appData.selectedItem.ext;
    },
    src() {
      const path = `${this.appData.selectedItem.path.join('/') }/`;

      if (this.appData.selectedItem) {
        if (!this.isFolder) {
          return (
            `${path + this.appData.selectedItem.id}.${this.appData.selectedItem.ext}`
          );
        }
      }

      return 'about: blank';
    },
    docViewConfig() {
      const me = this;

      let previewSrc;

      let docViewConfig = {};

      if (me.appData.selectedItem) {
        if (me.appData.selectedItem.previewFileName) {
          previewSrc =
            `${me.appData.selectedItem.path.join('/')
            }/${
              me.appData.selectedItem.previewFileName}`;
        }
        docViewConfig = {
          src: me.src,
          previewSrc,
          ext: me.appData.selectedItem.ext,
          noDisplayText: Text.getText('APP.NODISPLAYTEXT')
        };
      }

      return docViewConfig;
    },
    mask() {
      return window.json.masks[this.appData.selectedItem.mask];
    }
  }
};
</script>
